import Image from 'next/image';

import { Section, SectionHeader } from '@/components/atomic/nuclei';
import { staticMediaStoreBaseURL } from '@/config/common';
import { useIsMobile } from '@/helpers/screenResolutionHelper';

const whyHaflaWorksCards = [
  {
    description:
      'purpose-built models with deep event semantics, pricing intelligence, and supplier know-how (not generic chat).',
    icon: 'vertical-ai-advantage.svg',
    title: 'Vertical AI Advantage'
  },
  {
    description:
      'the widest, most reliable bench of suppliers to match every brief.',
    icon: 'marketplace-liquidity.svg',
    title: 'Marketplace Liquidity'
  },
  {
    description: 'shortlists in minutes, quotes in hours, precision execution.',
    icon: 'quality-at-speed.svg',
    title: 'Quality at Speed'
  },
  {
    description:
      'one partner from brief to breakdown; transparent budgets and clear timelines.',
    icon: 'accountable-delivery.svg',
    title: 'Accountable Delivery'
  }
];

const WhyHaflaWorks = () => {
  const [isMobile] = useIsMobile();
  return (
    <>
      <Section>
        <SectionHeader
          text='Why'
          gradientText='Hafla Works'
        />
        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8'>
          {whyHaflaWorksCards.map(({ title, description, icon }) => (
            <div
              key={title}
              className='bg-white rounded-xl shadow-md p-6 flex flex-col items-center text-center border border-pink-100 hover:border-pink-200 hover:shadow-xl transition-all ease-in-out cursor-pointer'
            >
              <div className='relative w-20 h-20 md:h-25 md:w-25 mb-6 rounded-full bg-rose-100 flex items-center justify-center'>
                <Image
                  alt={`${title} icon`}
                  height={isMobile ? 64 : 80}
                  width={isMobile ? 64 : 80}
                  style={{
                    width: isMobile ? '64px' : '80px',
                    height: isMobile ? '64px' : '80px',
                    objectFit: 'contain'
                  }}
                  priority={true}
                  src={`${staticMediaStoreBaseURL}/about-hafla/why-hafla-works/${icon}`}
                />
              </div>
              <div className='bg-control bg-clip-text text-transparent font-semibold text-xl md:text-2xl mb-3'>
                {title}
              </div>
              <div className='text-gray-700 text-sm md:text-base leading-relaxed'>
                {description}
              </div>
            </div>
          ))}
        </div>
      </Section>
      <div className='border-t border-pink-100 container mx-auto' />
    </>
  );
};

export default WhyHaflaWorks;
